import { ITRequestFormResponse } from '@Types/api/form';
import { RequestFormHeader } from '@Types/index';

export const prepareFormHeaderData = (
  formData: ITRequestFormResponse | undefined
): RequestFormHeader | undefined => {
  if (!formData) {
    return undefined;
  }

  return {
    reqStatusId: formData.statusId,
    createdDate: formData.reqDate,
    requestId: formData.requestId,
  };
};
